(function () {
  'use strict';

  function initMobileCompactPosts(root) {
    if (!root || root.dataset.mobileCompactPostsBound === 'true') return;

    var button = root.querySelector('[data-blog-posts-mobile-more]');
    if (!button) return;

    root.dataset.mobileCompactPostsBound = 'true';
    button.addEventListener('click', function () {
      root.classList.add('is-mobile-expanded');
      button.setAttribute('aria-expanded', 'true');
      button.hidden = true;
    });
  }

  function initMobileCompactPostsIn(scope) {
    if (!scope) return;

    if (scope.matches && scope.matches('[data-blog-posts]')) {
      initMobileCompactPosts(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-blog-posts]').forEach(initMobileCompactPosts);
    }
  }

  if (!window.radianBlogPostsMobileMoreInitialized) {
    window.radianBlogPostsMobileMoreInitialized = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initMobileCompactPostsIn(document);
      });
    } else {
      initMobileCompactPostsIn(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initMobileCompactPostsIn(event.target);
    });
  }

  if (customElements.get('blog-posts-split')) return;

  class BlogPostsSplit extends HTMLElement {
    connectedCallback() {
      this.featured = this.querySelector('.blog-posts-split__featured');
      this.list = this.querySelector('.blog-posts-split__list');
      this.lastCard = this.list && this.list.querySelector('.blog-posts-split__list-card:last-child');
      this.frame = null;

      if (!this.featured || !this.list || !this.lastCard) return;

      this.scheduleSync = this.scheduleSync.bind(this);
      this.resizeObserver = new ResizeObserver(this.scheduleSync);
      this.resizeObserver.observe(this.featured);
      this.resizeObserver.observe(this.lastCard);
      this.scheduleSync();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.list && this.list.style.removeProperty('--blog-overlap-release-runway');
    }

    scheduleSync() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.syncReleaseRunway();
      });
    }

    syncReleaseRunway() {
      if (!this.classList.contains('blog-posts-split--overlap')) {
        this.list.style.removeProperty('--blog-overlap-release-runway');
        return;
      }

      const featuredHeight = this.featured.getBoundingClientRect().height;
      const lastCardHeight = this.lastCard.getBoundingClientRect().height;
      const releaseRunway = Math.max(0, Math.ceil(featuredHeight - lastCardHeight));

      this.list.style.setProperty('--blog-overlap-release-runway', `${releaseRunway}px`);
    }
  }

  customElements.define('blog-posts-split', BlogPostsSplit);
})();
